import { TemplateCategoryModel } from 'templates/types';

const sortSubcategoriesAlphabetical = (data: Array<TemplateCategoryModel> | null) => {
  if (!data || data.length === 0) {
    return [];
  }
  const sorted = [...data].sort((a, b) => a.name.localeCompare(b.name));
  return sorted;
};

export default sortSubcategoriesAlphabetical;
